import React, { useEffect, useState } from 'react'
import type { MenuProps } from 'antd';
import { Dropdown, Empty, message, Skeleton, Space, Spin } from 'antd';
import { BiPencil, BiTrash } from 'react-icons/bi';
import { HiOutlineDotsVertical } from "react-icons/hi";
import { LoadingOutlined } from '@ant-design/icons';
import { useGeneralContext } from '../../../../context/generalContext';
import { BaseServices } from '../../../../helpers/baseServices';
import { global_variables } from '../../../../helpers/globalVariables';
import EditExistingPodcast from '../../../../components/shared/publish/editExistingPodcast';


const PublishedPodcasts = () => {

    const { reFetch, setReFetch } = useGeneralContext()
    const templateData = Array.from({ length: 4 })
    const [isFetching, setIsFetching] = useState(false)
    const [allPublished, setAllPublished] = useState([])
    const [selectedBook, setSelectedBook] = useState<any>(null)
    const [isBusy, setIsBusy] = useState(false)

    //story or book edit modal
    const [openFinishStory, setOpenFinishStory] = useState(false)
    const handleOpenFinishStory = () => {
        setOpenFinishStory(true)
    }
    const handleCloseFinishStory = () => {
        setOpenFinishStory(false)
    }

    //getAllPublished
    const getAllPublished = async () => {
        setIsFetching(true)
        try {
            const response = await BaseServices.get(`${global_variables.all_podcast_list}/?limit=${4}&status=Published`)
            // console.log("-----publishedPodcasts:", response)
            setAllPublished(response?.data?.results)
            setIsFetching(false)
        } catch (error) {
            console.log(error)
        }
    }


    //onload
    useEffect(() => {
        getAllPublished()
    }, [reFetch])



    //handleDeletePod
    const handleDeletePod = async () => {

        setIsBusy(true)
        try {
            const response = await BaseServices.delete(`${global_variables.podcats_url}/${selectedBook?.id}/delete/`)
            console.log("-----delPodResponse:", response)
            setIsBusy(false)
            message.success(`${selectedBook?.title || "Podcast"} has been deleted successfully!`)
            getAllPublished()
        } catch (error: any) {
            console.log("------delPodError:", error)
            setIsBusy(false)
            message.error(error?.details || error?.response?.data?.error || error?.response?.data?.detail || "An error occured please retry!")
        }
    }



    //dropdown
    const items: MenuProps['items'] = [
        {
            label: <button className='flex gap-2 items-center text-black text-opacity-[80%]' onClick={handleOpenFinishStory}>
                <BiPencil className='h-5 w-5' />
                <p>Edit</p>
            </button>,
            key: '1',
        },
        {
            label: <button className='flex gap-2 items-center text-red-500' onClick={handleDeletePod}>
                <BiTrash className='h-5 w-5' />
                <p>Delete</p>
            </button>,
            key: '3',
        },
    ];


    return (
        <>
            {
                isFetching ?
                    <>
                        <div className="2xl:grid xl:grid lg:grid md:grid grid-cols-2 w-full gap-10">
                            {
                                templateData.map((item, i) => (
                                    <div key={i} className="py-[25px] border-t-[1px] border-t-[#D7DBE1]">
                                        <div className="flex w-full lg:gap-[25px] gap-[15px] items-center">
                                            <div className='mb-5 lg:mb-0'>
                                                <Skeleton.Image style={{ width: 180, height: 130, borderRadius: 17 }} active />
                                            </div>

                                            <div className=' w-full'>
                                                <Skeleton active />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </>
                    :
                    allPublished.length === 0 ?
                        <>
                            <div className='mt-10'>
                                <Empty description={`You have no published Books`} />
                            </div>
                        </>
                        :
                        <div className="2xl:grid xl:grid lg:grid md:grid grid-cols-2 w-full gap-10">
                            {
                                allPublished.map((item: any, i: number) => (
                                    <div key={i} className="pr-5 border-[1px] border-[#D7DBE1] bg-white shadow-md rounded-[20px]">
                                        <div className="flex w-full items-center lg:gap-[25px] gap-[15px]">
                                            <div className='mb-5 lg:mb-0'>
                                                <img className='lg:w-[250px] w-[150px] h-[150px] rounded-[17px] object-cover' src={item?.cover_image || "https://imageresizer.furnituredealer.net/img/remote/images.furnituredealer.net/img/commonimages%2Fitem-placeholder.jpg"} alt="" />
                                            </div>

                                            <div className='flex justify-between lg:w-full'>
                                                <div className='text-black text-opacity-[80%]'>
                                                    <p className='text-[14px] font-[700]'>Title: <span className='font-[400]'>{item?.title}</span></p>

                                                    <p className='text-[14px] font-[700] mt-[3px]'>Author: <span className='font-[400]'>{item?.author || item?.hosts}</span></p>

                                                    {/* <p className='text-[14px] font-[700] mt-[3px]'>Price: <span className='font-[400]'>GHS {item?.price}</span></p> */}

                                                    <p className='text-[14px] font-[700] mt-[3px]'>Subscribers: <span className='font-[400]'>{item?.total_subscribers}</span></p>

                                                    <p className='text-[14px] font-[700] mt-[3px]'>Total Revenue: <span className='font-[400]'>{item?.total_revenue}</span></p>
                                                </div>

                                                <div>
                                                    {
                                                        item?.id === selectedBook?.id && isBusy ?
                                                            <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: "#000" }} spin />} />
                                                            :
                                                            <Dropdown className='hover:bg-gray-200 hover:rounded-full disabled:cursor-not-allowed cursor-pointer' menu={{ items }} trigger={['click']} placement='bottomCenter' disabled={isBusy}>
                                                                <button onClick={() => setSelectedBook(item)}>
                                                                    <Space>
                                                                        <HiOutlineDotsVertical className='h-6 w-6 text-black text-opacity-[80%]' />
                                                                    </Space>
                                                                </button>
                                                            </Dropdown>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
            }



            {/* finish edit podcast */}
            {
                openFinishStory && <EditExistingPodcast isOpened={openFinishStory} handleClose={handleCloseFinishStory} tempPodcastData={selectedBook} handleReFetch={() => setReFetch(!reFetch)} />
            }

        </>
    )
}

export default PublishedPodcasts
